import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles } from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IEntity } from '../main/entities';
import { OcEdit } from '../main/OcEdit';
import { transl } from '../main/transl';
import { MgColumnExtras } from '../mg/table/MgColumn';
import { adaptDataviewStoreColumn, IDataviewStoreColumn } from '../stores/DataviewStoreColumn';

const useStyles = makeStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		width: '100%',
	},
	input: {
		width: '100%',
		margin: 10,
	},
	disabledInputLabel: {
		color: '#F00',
	},
});

interface IEntityEditDialogStore {
	observableEntity : IEntity | undefined
	title: string
	errorText?(column: IDataviewStoreColumn) : string | boolean
	reasonForReadonly?(name: string) : string | boolean
	globalReasonForReadonly?: string | boolean
	cancel(): void
	accept(): void
	clone?(): void
}

interface IEntityEditDialogProps {
	store: IEntityEditDialogStore
	columns: Array<IDataviewStoreColumn>
	extras?: {[s: string]: MgColumnExtras}
}

export const EntityEditDialog = observer(function EntityEditDialog(props: IEntityEditDialogProps) {
	function acceptColumn(c) {
		const e = extras;
		if (!e) return true;
		const e2 = e[c.name];
		if (!e2) return true;
		if (!e2.hidden) return true;
		return false;
	}

	const classes = useStyles();
	const {store, extras} = props;
	let {columns} = props;
	columns = columns.filter(acceptColumn);
	const entity = store.observableEntity;
	if (!entity) return null;

	const errorTextMap: Map<IDataviewStoreColumn, string | boolean> =
			new Map(columns.map(c => [c, store.errorText ? store.errorText(c) : c.isRequired && !c.formatForView(entity)]));
	let hasError: boolean = false;
	for (const e of errorTextMap.values()) hasError = hasError || !!e;
	return <Dialog open={true} className={classes.root} onClose={store.cancel} fullWidth>
		<DialogTitle>{transl(store.title)}</DialogTitle>
		<DialogContent className={classes.content}>{
			columns.map(c => <OcEdit
				column={adaptDataviewStoreColumn(c)}
				entity={entity}
				reasonForReadonly={store.reasonForReadonly ? store.reasonForReadonly(c.name) : false}
				errorText={errorTextMap.get(c)}
				key={c.name}
				extras={extras && extras[c.name] || {}}
			/>)
		}</DialogContent>
		<DialogActions>
			{!store.clone ? null : <Button onClick={store.clone} color="secondary">{transl('clone')}</Button>}
			<Button onClick={store.accept} disabled={hasError || !!store.globalReasonForReadonly} color="primary">{transl('save')}</Button>
			<Button onClick={store.cancel}>{transl('cancel')}</Button>
		</DialogActions>
	</Dialog>;
});
